"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SymbolData = void 0;
const Logger_1 = require("@nolimitcity/slot-launcher/bin/utils/Logger");
const ReelSymbolName_1 = require("../../../../reelsymbol/ReelSymbolName");
const ServerEvent_1 = require("../../../../server/event/ServerEvent");
const EventHandler_1 = require("../../../../event/EventHandler");
const GameResources_1 = require("../../../../resource/GameResources");
/**
 * Created by SH on 28/7/2019.
 */
class SymbolData {
    static get DEFAULT_SYMBOL() {
        return this._defaultConfiguration;
    }
    constructor(defualtConfiguration) {
        this.SymbolsPreDefined = [];
        this.SpecialSymbols = [ReelSymbolName_1.ReelSymbolName.SCATTER, ReelSymbolName_1.ReelSymbolName.MYSTERY, ReelSymbolName_1.ReelSymbolName.BONUS];
        SymbolData._defaultConfiguration = defualtConfiguration;
        this.addEventListeners();
    }
    addEventListeners() {
        EventHandler_1.EventHandler.addEventListener(this, ServerEvent_1.ServerEvent.INIT_DATA_PARSED, (event) => this.InitDataReceived(event.params[0]));
    }
    InitDataReceived(data) {
        let result = Object.keys(data.symbolValues).map(function (symbolName) {
            return symbolName;
        });
        this.addSymbolData(result);
        this.addSymbolData(this.SpecialSymbols);
    }
    static InitSymbolData() {
        const keyNames = Object.keys(PIXI.utils.TextureCache).filter(function (path) {
            const splitted = path.split("/")[0];
            return splitted.length <= 2 && splitted !== "ui";
        });
        for (let i = 0; i < keyNames.length; i++) {
            for (let j = 0; j < SymbolData.Configs.length; j++) {
                if (keyNames[i].split("/")[0] == SymbolData.Configs[j].NAME) {
                    if (SymbolData.Configs[j].MULTISIZE) {
                        if (SymbolData.Configs[j].MULTI_STATES == undefined)
                            SymbolData.Configs[j].MULTI_STATES = {};
                        let ID = keyNames[i].split("/")[1];
                        let stateType = keyNames[i].split("/")[2].split("_")[1];
                        let State = {};
                        let parsedID = ID[1] == "T" ? parseInt(ID[0], 16) - 1 : parseInt(ID, 16) - 1;
                        const multiDIM = this.createMultiDimData(parsedID);
                        State[ID] = {};
                        State[ID][stateType] = { TEXTURE_PATH: keyNames[i], DIM: multiDIM };
                        if (Object.keys(SymbolData.Configs[j].MULTI_STATES).find(key => key == ID)) {
                            let Statearr = SymbolData.Configs[j].MULTI_STATES[ID];
                            Statearr[stateType] = State[ID][stateType];
                            SymbolData.Configs[j].MULTI_STATES[ID] = Statearr;
                        }
                        else if (SymbolData.Configs[j].MULTI_STATES) {
                            SymbolData.Configs[j].MULTI_STATES[ID] = State[ID];
                        }
                        else {
                            SymbolData.Configs[j].MULTI_STATES = State;
                        }
                    }
                    else {
                        let stateType = keyNames[i].split("/")[1].split("_")[1];
                        if (stateType == undefined)
                            stateType = "normal";
                        if (SymbolData.Configs[j].NORMAL_STATES) {
                            let deffState = SymbolData.Configs[j].NORMAL_STATES;
                            deffState[stateType] = { TEXTURE_PATH: keyNames[i], DIM: undefined };
                            SymbolData.Configs[j].NORMAL_STATES = deffState;
                        }
                        else {
                            let State = {};
                            State[stateType] = { TEXTURE_PATH: keyNames[i], DIM: undefined };
                            SymbolData.Configs[j].NORMAL_STATES = State;
                        }
                    }
                }
            }
        }
    }
    static createMultiDimData(ID) {
        const dim = {
            HEIGHT: this.DEFAULT_SYMBOL.DIM.HEIGHT,
            WIDTH: this.DEFAULT_SYMBOL.DIM.WIDTH,
            PADDING_X: this.DEFAULT_SYMBOL.DIM.PADDING_X,
            PADDING_Y: this.DEFAULT_SYMBOL.DIM.PADDING_Y,
            SCALE: this.DEFAULT_SYMBOL.DIM.SCALE,
        };
        return dim;
    }
    addSymbolData(arr) {
        arr.forEach(value => {
            let data = this.createSymbolData(value);
            let symData = {
                NAME: value,
                DIM: data.DIM,
                MULTISIZE: !!data.MULTISIZE,
                MULTI_STATES: data.MULTI_STATES,
                NORMAL_STATES: data.NORMAL_STATES,
            };
            SymbolData.Configs.push(symData);
        });
    }
    static getSymbolConfig(symName) {
        let objFetch = undefined;
        for (let i = 0; i < this.Configs.length; i++)
            if (this.Configs[i].NAME == symName)
                objFetch = this.Configs[i];
        if (objFetch)
            return objFetch;
        this._enableLogg && Logger_1.Logger.warn("Tried to find an undefined symbol: " + symName);
        this._enableLogg && Logger_1.Logger.warn("Returning emptyNamed symbol");
        return {
            NAME: "",
            DIM: SymbolData._defaultConfiguration.DIM,
        };
    }
    static getTextureFromConfig(config, state, multiState) {
        let texturePath = undefined;
        if (config.MULTISIZE) {
            if (config.MULTI_STATES && config.MULTI_STATES[multiState]) {
                const stateData = config.MULTI_STATES[multiState][state];
                if (stateData)
                    texturePath = stateData.TEXTURE_PATH;
                else {
                    this._enableLogg && Logger_1.Logger.warn("Missing state:" + state + ", for symbol: " + config.NAME);
                    if (state == "normal")
                        return undefined;
                    this._enableLogg && Logger_1.Logger.warn("Trying to fetch normal state instead.");
                    return this.getTextureFromConfig(config, "normal", multiState);
                }
            }
            else
                this._enableLogg && Logger_1.Logger.warn("Missing MultiStates:" + multiState + " for symbol: " + config.NAME);
        }
        else if (config.NORMAL_STATES) {
            const stateData = config.NORMAL_STATES[state];
            if (stateData)
                texturePath = stateData.TEXTURE_PATH;
            else {
                this._enableLogg && Logger_1.Logger.warn("Missing state:" + state + ", for symbol: " + config.NAME);
                if (state == "normal")
                    return undefined;
                this._enableLogg && Logger_1.Logger.warn("Trying to fetch normal state instead.");
                return this.getTextureFromConfig(config, "normal", multiState);
            }
        }
        else {
            this._enableLogg && Logger_1.Logger.warn("There is no TextureStates defined for symbol:" + config.NAME);
        }
        if (texturePath)
            return GameResources_1.GameResources.getTextures(texturePath);
        else
            return undefined;
    }
    static getDimFromConfig(config, state, multiState) {
        let dimData = undefined;
        if (config.MULTISIZE) {
            if (config.MULTI_STATES && config.MULTI_STATES[multiState]) {
                const stateData = config.MULTI_STATES[multiState][state];
                if (stateData)
                    dimData = stateData.DIM;
                else {
                    this._enableLogg && Logger_1.Logger.warn("Missing state:" + state + ", for symbol: " + config.NAME);
                    if (state == "normal")
                        return undefined;
                    this._enableLogg && Logger_1.Logger.warn("Trying to fetch normal state instead.");
                    return this.getDimFromConfig(config, "normal", multiState);
                }
            }
            else
                this._enableLogg && Logger_1.Logger.warn("Missing MultiStates:" + multiState + " for symbol: " + config.NAME);
        }
        else if (config.NORMAL_STATES) {
            const stateData = config.NORMAL_STATES[state];
            if (stateData)
                dimData = stateData.DIM;
            else
                this._enableLogg && Logger_1.Logger.warn("Missing state:" + state + ", for symbol: " + config.NAME);
        }
        else {
            this._enableLogg && Logger_1.Logger.warn("There is no TextureStates defined for symbol:" + config.NAME);
        }
        return dimData;
    }
    static getTextures(symName, state, multiState) {
        let config = SymbolData.getSymbolConfig(symName);
        return this.getTextureFromConfig(config, state, multiState);
    }
    static isSpecialSymbol(symName) {
        const confSym = SymbolData.getSymbolConfig(symName);
        if (!confSym)
            return false;
        return confSym.NAME === ReelSymbolName_1.ReelSymbolName.WILD ||
            confSym.NAME === ReelSymbolName_1.ReelSymbolName.SCATTER ||
            confSym.NAME === ReelSymbolName_1.ReelSymbolName.MYSTERY ||
            confSym.NAME === ReelSymbolName_1.ReelSymbolName.BONUS;
    }
    static isMultiSymbolExpanding(symName) {
        return symName[0] == "L";
    }
    static isExpandingSymbol(symName) {
        return symName == ReelSymbolName_1.ReelSymbolName.MYSTERY;
    }
    createSymbolData(symType) {
        let newSymData;
        for (var i = 0; i < this.SymbolsPreDefined.length; i++) {
            if (this.SymbolsPreDefined[i].NAME == symType) {
                newSymData = {
                    NAME: symType,
                    DIM: this.SymbolsPreDefined[i].DIM ? this.SymbolsPreDefined[i].DIM : SymbolData.DEFAULT_SYMBOL.DIM,
                    MULTISIZE: !!this.SymbolsPreDefined[i].MULTISIZE,
                    MULTI_STATES: this.SymbolsPreDefined[i].MULTI_STATES,
                    NORMAL_STATES: this.SymbolsPreDefined[i].NORMAL_STATES
                };
                return newSymData;
            }
        }
        return {
            NAME: symType,
            DIM: SymbolData.DEFAULT_SYMBOL.DIM,
            MULTISIZE: false,
        };
    }
}
SymbolData.Configs = [];
SymbolData._enableLogg = false;
exports.SymbolData = SymbolData;
//# sourceMappingURL=SymbolData.js.map